import React, { createContext, useContext, useState } from 'react';

const InboxContext = createContext();

export const InboxProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refreshInbox = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <InboxContext.Provider value={{ refreshTrigger, refreshInbox }}>
      {children}
    </InboxContext.Provider>
  );
};

export const useInbox = () => useContext(InboxContext);